// removed by extract-text-webpack-plugin
module.exports = {"container":"ConfirmTemplate__container___35Q3k"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/ConfirmTemplate.less
 ** module id = 757
 ** module chunks = 0
 **/